<template>
    <div class="w-100 h-100">
        <h1 class="display-2">{{title}}</h1>

        <div>
    <b-button-group size="lg">
      <b-button :variant="read === 1 ? 'primary' : 'secondary'" @click="switchRead(1)">Read 1</b-button>
      <b-button :variant="read === 2 ? 'primary' : 'secondary'" @click="switchRead(2)">Read 2</b-button>
      <b-button :variant="read === 3 ? 'primary' : 'secondary'" @click="switchRead(3)" :disabled="read_3_disabled">Read 3</b-button>
    </b-button-group>
  </div>

  <b-container fluid>
      <b-row>
        <b-col md="12" lg="8" xl="6">



        <b-container fluid class="bg-white rounded mt-3 py-2 float-left">
            <b-row class="border-bottom mx-1">
                <b-col sm="12" md="4" class="mb-0 pb-0 mb-sm-1 pb-sm-1">
                    <label>FN Objective:</label>
                </b-col>
                <b-col sm="12" md="8" class="mt-0 pt-0 mt-sm-1 pt-sm-1">
                    <b-form-select v-model="form.fn_objective">
                        <option :value="null">Please select an option</option>
                        <option value="0.18">0.18</option>
                        <option value="0.20">0.20</option>
                        <option value="0.22">0.22</option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="border-bottom mx-1">
                <b-col sm="12" md="4" class="mb-0 pb-0 mb-sm-1 pb-sm-1">
                    <label>Asx Para:</label>
                </b-col>
                <b-col sm="12" md="8" class="mt-0 pt-0 mt-sm-1 pt-sm-1">
                    <b-form-input v-model="form.asx_para"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="border-bottom mx-1">
                <b-col sm="12" md="4" class="mb-0 pb-0 mb-sm-1 pb-sm-1">
                    <label>Species:</label>
                </b-col>
                <b-col sm="12" md="8" class="mt-0 pt-0 mt-sm-1 pt-sm-1">
                    <b-form-select v-model="form.species">
                        <option :value="null">Please select an option</option>
                        <option value="Pf">Pf</option>
                        <option value="Pm">Pm</option>
                        <option value="Po">Po</option>
                        <option value="Pv">Pv</option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="border-bottom mx-1">
                <b-col sm="12" md="4" class="mb-0 pb-0 mb-sm-1 pb-sm-1">
                    <label>Blood Volume:</label>
                </b-col>
                <b-col sm="12" md="8" class="mt-0 pt-0 mt-sm-1 pt-sm-1">
                    <b-form-select v-model="form.vol_blood">
                        <option :value="null">Please select an option</option>
                        <option value="0.00135">0.00135</option>
                        <option value="0.00167">0.00167</option>
                        <option value="0.00202">0.00202</option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="border-bottom mx-1">
                <b-col sm="12" md="4" class="mb-0 pb-0 mb-sm-1 pb-sm-1">
                    <label>MCR Result:</label>
                </b-col>
                <b-col sm="12" md="8" class="mt-0 pt-0 mt-sm-1 pt-sm-1">
                    <b-form-select v-model="form.mcr_result">
                        <option :value="null">Please select an option</option>
                        <option value="Neg">Neg</option>
                        <option value="Pos">Pos</option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="border-bottom mx-1">
                <b-col sm="12" md="4" class="mb-0 pb-0 mb-sm-1 pb-sm-1">
                    <label>Para Density:</label>
                </b-col>
                <b-col sm="12" md="8" class="mt-0 pt-0 mt-sm-1 pt-sm-1">
                    <b-form-input v-model="form.para_density"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="border-bottom mx-1">
                <b-col sm="12" md="4" class="mb-0 pb-0 mb-sm-1 pb-sm-1">
                    <label>Gametocytes:</label>
                </b-col>
                <b-col sm="12" md="8" class="mt-0 pt-0 mt-sm-1 pt-sm-1">
                    <b-form-select v-model="form.gametocytes">
                        <option :value="null">Please select an option</option>
                        <option value="No">No</option>
                        <option value="Yes">Yes</option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="mx-1">
                <b-col sm="12" md="4" class="mb-0 pb-0 mb-sm-1 pb-sm-1">
                </b-col>
                <b-col sm="12" md="8" class="mt-0 pt-0 mt-sm-1 pt-sm-1">
                    <b-button @click="save()" size="lg" variant="success" class="w-100">Save</b-button>
                </b-col>
            </b-row>
        </b-container>

        </b-col>
      </b-row>
  </b-container>

    </div>
</template>

<script>
    // import {
    //     HTTP
    // } from '@/utilities/http-common';
    // import HandleErrors from '@/utilities/handle-errors';

    // import BaseTemplate from '@/layouts/BaseTemplate.vue'
    import {
        mapState, mapGetters, mapActions
    } from "vuex";
    import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

    import _ from 'lodash';

    export default {
        mixins: [
            // BaseTemplate,
            DashboardBaseTemplate
        ],
        components: {},
        data: function () {
            return {
                title: "Thick Film Counting",
                form: {
                    fn_objective: null,
                    asx_para: null,
                    species: null,
                    vol_blood: null,
                    mcr_result: null,
                    para_density: null,
                    gametocytes: null
                },
                read: 1,
                entry: null,
                index: 0,
                read_3_disabled: true,
                cols: ['fn_objective', 'asx_para', 'species', 'vol_blood', 'mcr_result', 'para_density', 'gametocytes']
            };
        },
        computed: {
            ...mapState("sample", ["sample"]),
            ...mapGetters('smicroscopy', ['getByIndex'])
        },
        created: function () {
            
        },
        mounted: function () {
            this.index = parseInt(this.$route.params.index);
            let read = this.$route.query.read ? parseInt(this.$route.query.read) : 1;
            this.entry = this.getByIndex(this.index);
            this.switchRead(read);
            
            // Calculate read3
            this.checkRead3();
        },
        methods: {
            ...mapActions('smicroscopy', ['updateEntry']),
            get: function () {
                // HTTP.get('/').then((response) => {
                //     let something = response.data;
                // }).catch((error) => {
                //     HandleErrors.HandleErrors(error);
                // });
            },
            find: function () {},
            patch: function () {},
            delete: function () {},
            save: function () {
                let payload = {index: parseInt(this.$route.params.index)};
                payload['fn_objective_' + this.read] = this.form.fn_objective;
                payload['asx_para_' + this.read] = this.form.asx_para;
                payload['species_' + this.read] = this.form.species;
                payload['vol_blood_' + this.read] = this.form.vol_blood;

                payload['mcr_result_' + this.read] = this.form.mcr_result;
                payload['para_density_' + this.read] = this.form.para_density;
                payload['gametocytes_' + this.read] = this.form.gametocytes;
                this.updateEntry(payload);

                // Calculate read3
                this.checkRead3();
            },
            switchRead: function(read) {
                this.read = read;
                this.form.fn_objective = this.entry['fn_objective_' + this.read];
                this.form.asx_para = this.entry['asx_para_' + this.read];
                this.form.species = this.entry['species_' + this.read];
                this.form.vol_blood = this.entry['vol_blood_' + this.read];

                this.form.mcr_result = this.entry['mcr_result_' + this.read];
                this.form.para_density = this.entry['para_density_' + this.read];
                this.form.gametocytes = this.entry['gametocytes_' + this.read];
            },
            checkRead3: function() {
                this.read_3_disabled = true;
                
                let entry = this.getByIndex(this.index);

                if ((entry.species_1 && entry.species_2) && (entry.species_1 != entry.species_2)) {
                    this.read_3_disabled = false;
                }

                if ((entry.mcr_result_1 && entry.mcr_result_2) && (entry.mcr_result_1 != entry.mcr_result_2)) {
                    this.read_3_disabled = false;
                }

                let a = parseInt(entry.para_density_1);
                let b = parseInt(entry.para_density_2);
                if ((_.isFinite(a) && _.isFinite(b)) && ((a + b) >= 400)) {
                    if((a / b) >= 2 || (b / a) >= 2) {
                        this.read_3_disabled = false;
                    }
                }

                if ((_.isFinite(a) && _.isFinite(b)) && ((a + b) < 400)) {
                    if((a / b) >= 10 || (b / a) >= 10) {
                        this.read_3_disabled = false;
                    }
                }

                
            }
        }
    };
</script>